import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const NestedCheckboxContainer = styled.form<{ $isPrivate?: boolean }>`
  border-radius: 5px;
  background-color: ${({ theme }) => theme.white.a10};
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
`;

export const Header = styled.span<{ $isPrivate?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 1.333rem 2rem;
  font-size: 1.4rem;
  border-bottom: ${({ $isPrivate, theme }) => (!$isPrivate ? `1px solid ${theme.black.a1}` : 'none')};
`;

export const ToolTipImgWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ImgWrapper = styled.div`
  padding: 30px;
  background-color: ${({ theme }) => theme.baseBlue.a10};
  margin-left: -16px;
  margin-bottom: -12px;
  height: 415px;
  width: 480px;
`;

export const SpinnerContainer = styled.div`
  padding: 60px;
`;

export const EmptyMessage = styled.div`
  padding: 2rem;
  text-align: center;
  display: block;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const ButtonsSection = styled.div`
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  margin-left: 1rem;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
`;

export const LinkWrapper = styled.div`
  opacity: 0.65;
  height: 43px;
  display: flex;
  align-items: center;
`;

export const ButtonLink = styled(Link)`
  text-decoration: underline;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin-left: 3px;
`;

export const IconMargin = styled.div`
  margin-left: 5px;
`;

export const AddFormWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  padding: 1.2666rem 2rem 1.2666rem 2rem;
  overflow: hidden;
`;
